var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAchievements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 17.5C2.66675 16.3215 2.66675 15.7322 3.03286 15.3661C3.39898 15 3.98824 15 5.16675 15H6.83341C8.01193 15 8.60118 15 8.9673 15.3661C9.33341 15.7322 9.33341 16.3215 9.33341 17.5V18.3333H2.66675V17.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.834L6 15.0007",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.334H11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86382 2.3881L7.74372 4.16245C7.86371 4.40945 8.18367 4.64637 8.45364 4.69173L10.0485 4.95889C11.0684 5.13028 11.3083 5.87631 10.5734 6.61226L9.33354 7.86237C9.12357 8.07408 9.00858 8.48239 9.07357 8.77475L9.42853 10.3223C9.7085 11.5472 9.06357 12.021 7.98869 11.3808L6.49386 10.4886C6.22389 10.3273 5.77894 10.3273 5.50397 10.4886L4.00913 11.3808C2.93925 12.021 2.28932 11.5421 2.56929 10.3223L2.92425 8.77475C2.98925 8.48239 2.87426 8.07408 2.66428 7.86237L1.42442 6.61226C0.6945 5.87631 0.929474 5.13028 1.94936 4.95889L3.54419 4.69173C3.80916 4.64637 4.12912 4.40945 4.24911 4.16245L5.12901 2.3881C5.60896 1.42532 6.38887 1.42532 6.86382 2.3881Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAchievements);
export default __webpack_public_path__ + "static/media/icon-achievements.9d5fbb2aac685c8f8f27ad25bf959f55.svg";
export { ForwardRef as ReactComponent };